import { render, staticRenderFns } from "./questionCreate.vue?vue&type=template&id=7c42c967&scoped=true&"
import script from "./questionCreate.vue?vue&type=script&lang=js&"
export * from "./questionCreate.vue?vue&type=script&lang=js&"
import style0 from "./questionCreate.vue?vue&type=style&index=0&id=7c42c967&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c42c967",
  null
  
)

export default component.exports